<template>
    <div>
        <div class="ml-md-4">
            <b-overlay :show="loading" spinner-variant="primary" rounded="sm">
                <div class="mt-4 bg-white p-4 round-unify">
                    <h3 v-html="$t('messages.javascriptIntro')"></h3>
                    <br />
                    <b-form @submit.stop.prevent="handleSubmit" ref="createResource" class="">
                        <b-form-group
                            id="input-group-JavaScript"
                            :label="$t('labels.javascriptsnippet')"
                            label-for="input-JavaScript"
                            :description="$t('messages.javascriptNoScriptTags')"
                        >
                            <b-form-textarea
                                id="input-JavaScript"
                                :placeholder="$t('placeholders.javascriptcode')"
                                rows="3"
                                style="border-radius: 16px"
                                v-model="space['Javascript']"
                            ></b-form-textarea>
                        </b-form-group>
                        <p v-html="$t('messages.javascriptPlaceholders')"></p>
                        <div class="d-flex align-items-center justify-content-end">
                            <b-button variant="primary" type="submit">{{ $t('labels.save') }}</b-button>
                        </div>
                    </b-form>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import EventBus from '../../../eventBus';

export default {
    name: 'JavaScript',

    data() {
        return {
            loading: false,
            space: null,
        };
    },
    created() {
        this.getSpaceSettings();
    },
    methods: {
        handleSubmit() {
            this.loading = true;

            const data = JSON.stringify(this.space);
            axios({
                method: 'PUT',
                url: '/admin/space/settings',
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response && response.data) {
                        this.space = response.data;
                        const msg = {
                            Message: 'Changes saved',
                            Details: '',
                        };
                        EventBus.$emit('INFO', msg);
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    const msg = {
                        Message: 'Failed to save space settings',
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                });
        },
        getSpaceSettings() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/space/settings',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response && response.data) {
                        this.space = response.data;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    const msg = {
                        Message: 'Failed to get space settings',
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                });
        },
    },
};
</script>
